import request from '../request';

export const createBooking = (data = {}) =>
  request.post('bookings', data).then((res) => res);

export const getBookingById = (bookingId = '', bookingKey = '') =>
  request
    .get(`bookings/${bookingId}?bookingkey=${bookingKey}`)
    .then((res) => res);

export const createPassenger = (data = {}) =>
  request.post('bookingpassengers', data).then((res) => res);

export const createPassengers = (bookingid = '', data = {}) =>
  request.post(`bookings/${bookingid}/passengers`, data).then((res) => res);

export const updateBookingPassenger = async (
  tripid = '',
  bookingid = '',
  bookingpassengerid = '',
  data = {}
) => {
  return request
    .put(
      `/trips/${tripid}/bookings/${bookingid}/bookingpassengers/${bookingpassengerid}/passengerfields`,
      data
    )
    .then((res) => res);
};

export const generatePassengersPdf = async (data = {}) => {
  const resp = await request
    .post('bookingpassengers/pdf', data)
    .then((res) => res);
  return resp;
};

export const getTripBookingPassenger = (tripid = '') => {
  return request.get(`/trips/${tripid}/bookingpassengers`).then((res) => res);
};

// @ts-ignore
export const getTokenFromEsignatureProvider = async (trip, data) => {
  return request
    .post(`bookings/trip/${trip?.tripid}/generate-signed-document`, data)
    .then((res) => ({
      token: res?.data?.recipients?.[0]?.token,
      documentId: res?.data?.documentId
    }));
};

export const getBookingPaymentInfo = async (bookingid = '') => {
  return request.get(`/bookings/${bookingid}/payment-info`).then((res) => res);
};

export const getTripBookings = async (tripId = '') => {
  return request.get(`/bookings/trip/${tripId}`).then((res) => res);
};

export const requestPaymentRefund = async (refundid = '', data = {}) => {
  return request
    .post(`/payments/stripe/refund/${refundid}`, data)
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
};

export const getManageBookingById = (bookingId = '') =>
  request.get(`bookings/${bookingId}/manage`).then((res) => res);

export const deleteManageBookingPassengers = (bookingId = '', data = {}) =>
  request.delete(`bookings/${bookingId}/manage`, { data }).then((res) => res);

export const updateBookingPlan = (
  bookingId = '',
  bookingPlanId = '',
  data = {}
) =>
  request
    .put(`bookings/${bookingId}/bookingplan/${bookingPlanId}`, data)
    .then((res) => res);
